import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { ContractorUserAssignModel } from 'src/app/models/supplier-user-assign.model';
import { UserModel } from 'src/app/models/user.model';
import { ContractorUserAssignService } from 'src/app/services/contractor-user-assign.service';
import { ToastService } from 'src/app/services/toast.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { AsyncPipe } from '@angular/common';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatOption } from '@angular/material/select';

@Component({
    selector: 'app-supplier-user-assign',
    templateUrl: './supplier-user-assign.component.html',
    styleUrls: ['./supplier-user-assign.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, AsyncPipe]
})
export class SupplierUserAssignComponent implements OnInit {
  dialogRef = inject<MatDialogRef<SupplierUserAssignComponent>>(MatDialogRef);
  eventData = inject(MAT_DIALOG_DATA, { optional: true });
  toastr = inject(ToastService);
  contractorUserAssignSrv = inject(ContractorUserAssignService);
  private readonly userSvc = inject(UserManagementService);

  contractorUserForm = this.getForm();
  users: UserModel[] = [];
  filteredOptions!: Observable<UserModel[]>;
  previusUser: boolean = false;

  ngOnInit(): void {
    this.getUsers();

    this.contractorUserForm.controls.sellerName.valueChanges.subscribe(
      (value) => {
        value = !value ? '' : value;
        const filterValue = value.toLowerCase();

        let result = this.users.filter((option) =>
          option.name.toLowerCase().includes(filterValue)
        );
        this.filteredOptions = of(result);
      }
    );

    this.contractorUserForm.controls.contractorId.patchValue(
      this.eventData.data.id
    );
    this.contractorUserForm.controls.contractorName.patchValue(
      this.eventData.data.fullName
    );

    this.contractorUserForm.controls.contractorName.disable();
    this.contractorUserForm.controls.sellerName.disable();
  }

  selectUser(user: UserModel) {
    this.contractorUserForm.controls.sellerId.patchValue(user.id);
  }

  getUsers() {
    this.userSvc.getUsers().subscribe((data: UserModel[]) => {
      this.users = data;
      this.getContractorUserAssignModel();
    });
  }

  closeClick() {
    this.dialogRef.close();
  }

  getContractorUserAssignModel() {
    this.contractorUserAssignSrv.get(this.eventData.data.id).subscribe({
      next: (data) => {
        if (data) {
          this.previusUser = true;
          let user = this.users.find((option) => option.id == data.userId);
          this.contractorUserForm.controls.sellerId.setValue(data.userId);
          this.contractorUserForm.controls.sellerName.setValue(user?.name);
          this.contractorUserForm.controls.sellerName.setValue(user?.name, {
            emitEvent: true,
          });
        }

        this.contractorUserForm.controls.sellerName.enable();
      },
    });
  }

  displayFn(value: string): string {
    return value || '';
  }

  save() {
    let form = this.contractorUserForm.value;

    const model: ContractorUserAssignModel = {
      contractorId: form.contractorId,
      userId: form.sellerId,
    };

    this.contractorUserAssignSrv.save(model).subscribe({
      next: () => {
        this.toastr.success(
          'Asociación de usuario',
          'El usuario se asignó correctamente.'
        );
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.toastr.error(
          'Error',
          'No se pudo asignar el usuario al prestador seleccionado.'
        );
      },
    });
  }

  getForm(): UntypedFormGroup {
    return new UntypedFormGroup({
      contractorId: new UntypedFormControl('', Validators.required),
      contractorName: new UntypedFormControl(''),
      sellerId: new UntypedFormControl('', Validators.required),
      sellerName: new UntypedFormControl(''),
    });
  }
}
